// extracted by mini-css-extract-plugin
module.exports = {"icon":"TableDataSocial_icon__2RgnW","center":"TableDataSocial_center__VUOo1"};